import { InspectionTaskJobStatus } from '@euler/model/enum';
import { StoreWorkshopJob } from '@euler/model/StoreWorkshopJob';
import { dateFromValue } from '@euler/utils/datetime';

/** An open construction job as the board shows it. */
export type WorkshopJob = {
  id: number;
  taskId: number;
  licensePlateNo: string;
  name: string;
  status: InspectionTaskJobStatus;
  technicianName: string | null;
  /** Its group and team, as `机修 · A组`; null when it has neither. */
  team: string | null;
  /** Null until the job is begun. */
  startedAt: Date | null;
};

export function workshopJobFromItem(item: StoreWorkshopJob): WorkshopJob {
  return {
    id: item.id,
    taskId: item.taskId,
    licensePlateNo: item.licensePlateNo,
    name: item.name,
    status: item.status,
    technicianName: item.technicianName || null,
    team: [item.groupName, item.teamName].filter(Boolean).join(' · ') || null,
    startedAt: item.startedAt ? dateFromValue(item.startedAt) : null,
  };
}
